import React from "react";
import IconClutch from "assets/images/rating-clutch.png";
import IconUpwork from "assets/images/rating-upwork.png";

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="section-title text-white">
          <h1>contact us</h1>
          <p>Transforming product ideas to digital reality Transforming product ideas to digital reality.</p>
        </div>
        <div className="row">
          <div className="col-lg-8 contant-form">
            <form>
              <div className="row">
                <div className="form-group col-12">
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="How can we help you?"
                  />
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <input type="text" className="form-control" id="exampleInputPassword1" placeholder="Name" />
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <input type="email " className="form-control " id="exampleInputPassword1 " placeholder="Email " />
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <input type="number" className="form-control" id="exampleInputPassword1" placeholder="Phone" />
                </div>
                <div className="form-group col-lg-6 col-md-6">
                  <input type="text" className="form-control " id="exampleInputPassword1 " placeholder="Company" />
                </div>
                <div className="form-group col-12">
                  <textarea type="text" id="message" name="message" rows="5" placeholder="Massege..." className="form-control md-textarea"></textarea>
                </div>
              </div>
              <button className="btn btn-outline-blue my-2 my-sm-0 float-right" type="submit">
                SEND
              </button>
            </form>
          </div>
          <div className="col-lg-4">
            <div className="rated-by">
              <img src={IconClutch} width="160px" className="mr-3" alt="Clutch rating" />
              <img src={IconUpwork} width="135px" alt="Upwork rating" />
            </div>
            <div className="contant-info">
              <div className="info-block">
                <span className="icon-wrap">
                  <i className="fas fa-map-marker-alt"></i>
                </span>
                <p>Suite #34, First Floor, Suleiman Square, Gulberg-3, Lahore, Pakistan</p>
              </div>
              <div className="info-block">
                <span className="icon-wrap">
                  <i className="fas fa-phone"></i>
                </span>
                <p>+92 331 4155089, +92 333 4475583</p>
              </div>
              <div className="info-block">
                <span className="icon-wrap">
                  <i className="fas fa-envelope"></i>
                </span>
                <p>contact@transcendsol.com</p>
              </div>
            </div>
            <div className="social-icons">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f "></i>
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter pl-3"></i>
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in pl-3"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
